export default "__VITE_ASSET__Cl_Zr$5S__"